import { ReactComponent } from "./left_fold.svg";

const LeftFoldIcon = () => <ReactComponent />;

export default LeftFoldIcon;
